/**
 * DateFormat based on Dayjs formatting rules
 * See {@link https://day.js.org/docs/en/display/format}
 */
export enum DateFormat {
  API_DATE = 'YYYY-MM-DD',
  ARRIVAL_DATE_LONG = 'MMMM Do YYYY',
  ARRIVAL_DATE_SHORT = 'MMMM Do'
}
